import { render, staticRenderFns } from "./audio-file.vue?vue&type=template&id=7f39610f&"
import script from "./audio-file.vue?vue&type=script&lang=js&"
export * from "./audio-file.vue?vue&type=script&lang=js&"
import style0 from "./audio-file.vue?vue&type=style&index=0&id=7f39610f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports